import { nextfetch } from '@/shared/api/nextfetch'

type Data = {
	NAME: string
	LAST_NAME?: string
	EMAIL: string
	PHONE: string
	STORE_ID: string
	COMMENT?: string
	USER_TYPE: string

	TYPE: string
	SCRIPT_ID: string
	SEND_URL: string
	COMMENTS?: string
}

export const formRequest = async (formData: Partial<Data>) => {
	return await nextfetch<void>(`b24-lead-add`, {
		method: 'POST',
		params: formData,
		credentials: 'include'
	})
}

export type ServiceMindboxRegisterPayload = {
	NAME: string
	PHONE: string
	EMAIL: string
	TITLE: string
	URL: string
	SEND_TEXT: string
	IS_INDIVIDUAL: 'true' | 'false'
}

export const submitServiceMindboxRegister = async (payload: ServiceMindboxRegisterPayload): Promise<void> => {
	await nextfetch<void>(`service-product/mindbox/register`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(payload),
		credentials: 'include'
	})
}
